import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { CargoInputModel } from '../../Cargo/models/CargoInputModel';

interface cargoQuickInputState {
    cargoInput: CargoInputModel,
    selectedCargoId: string,
    triggerFocusChartererInput: number,
    triggerSave: number,
    triggerRefreshInput: number
}

const initialState: cargoQuickInputState = {
    cargoInput: {
        id: "",
        charterer: "",
        orderDetail: "",
        cargoType: 0,
        dwtMin: null,
        dwtMax: null,
        loadPort: 0,
        disport: 0,
        lay: "",
        can: "",
        remarks: ""
    } as CargoInputModel,
    selectedCargoId: "",
    triggerFocusChartererInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0
}

export const CargoQuickInputSlice = createSlice({
    name: "CargoQuickInput",
    initialState,
    reducers: {
        setCargoInputId: (state, action: PayloadAction<string>) => {
            state.cargoInput.id = action.payload;
        },
        setCharterer: (state, action: PayloadAction<string>) => {
            state.cargoInput.charterer = action.payload;
        },
        setOrderDetail: (state, action: PayloadAction<string>) => {
            state.cargoInput.orderDetail = action.payload;
        },
        setCargoType: (state, action: PayloadAction<number>) => {
            state.cargoInput.cargoType = action.payload;
        },
        setDwtMin: (state, action: PayloadAction<number | null>) => {
            state.cargoInput.dwtMin = action.payload;
        },
        setDwtMax: (state, action: PayloadAction<number | null>) => {
            state.cargoInput.dwtMax = action.payload;
        },
        setLoadPort: (state, action: PayloadAction<number>) => {
            state.cargoInput.loadPort = action.payload;
        },
        setDisport: (state, action: PayloadAction<number>) => {
            state.cargoInput.disport = action.payload;
        },
        setLay: (state, action: PayloadAction<string>) => {
            state.cargoInput.lay = action.payload;
        },
        setCan: (state, action: PayloadAction<string>) => {
            state.cargoInput.can = action.payload;
        },
        setRemarks: (state, action: PayloadAction<string>) => {
            state.cargoInput.remarks = action.payload;
        },
        setSelectedCargoId: (state, action: PayloadAction<string>) => {
            state.selectedCargoId = action.payload;
        },
        setTriggerFocusChartererInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusChartererInput = action.payload;
        },
        resetCargoInput: (state) => {
            state.cargoInput = initialState.cargoInput;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
    }
});

export const cargoQuickInputSelector = createSelector(
    (state: RootState) => state.cargoQuickInput,
    (data) => data
);

export const {
    setCargoInputId,
    setCharterer,
    setOrderDetail,
    setCargoType,
    setDwtMin,
    setDwtMax,
    setLoadPort,
    setDisport,
    setLay,
    setCan,
    setRemarks,
    setSelectedCargoId,
    setTriggerFocusChartererInput,
    resetCargoInput,
    setTriggerSave,
    setTriggerRefreshInput
} = CargoQuickInputSlice.actions;

export default CargoQuickInputSlice.reducer;